import { colorsPalettes } from "@similarweb/styles";
import { WidgetDraggableHolder } from "app/dashboards/view-components/WidgetContainerTemplateStyles-v2";
import styled from "styled-components";

export const DashboardWidgetContainer = styled.div`
    background: white;
    box-shadow: 0px 3px 6px rgb(14 30 62 / 8%);
    border-radius: 6px;
    overflow: hidden;

    .pos {
        color: black;
        font-size: 14px;
        height: 10px;
        margin-left: 1rem;
        margin-bottom: 1rem;
    }

    .hover {
        position: absolute;
        top: -3px;
        left: 7px;
        z-index: 10;
    }
`;
DashboardWidgetContainer.displayName = "WidgetContainer";

export const DashboardLoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
`;

export const GridContainer = styled.div<{
    marginTop?: number;
}>`
    position: relative;
    transition: height 200ms ease;

    margin-top: ${({ marginTop }) => marginTop ?? 0}px;
    margin-left: -25px;
    padding-left: 10px;

    ${WidgetDraggableHolder} {
        &:hover {
            cursor: grab;
        }
    }

    .react-grid-item.react-draggable-dragging {
        cursor: grabbing;

        ${WidgetDraggableHolder} {
            &:hover {
                cursor: grabbing;
            }
        }
    }

    .react-grid-item.react-grid-placeholder {
        background: ${colorsPalettes.bluegrey["500"]};
        opacity: 0.2;
        transition-duration: none;
        z-index: 1;
        user-select: none;
        position: absolute;
    }

    @media print {
        .layout {
            background: transparent;
        }

        .swWidget {
            border-radius: 6px;
            margin-bottom: 0 !important;
            overflow: hidden;
        }

        .swWidget-frame {
            padding: 20px;
            height: 340px;
        }

        .inline-flag {
            /* Styled components not working in savePDF mode, since style tag is empty */
            width: 1em;
            height: 1em;
        }

        background-color: transparent;
        min-height: auto;

        .innerWrap.dashboard-wrap {
            max-width: 1200px;
            margin: 0;
        }

        .swHeader-title {
            color: #2a3e52 !important;
        }

        .swWidget-dashboard-subTitle {
            padding-inline-start: 0;
            align-items: center;
        }

        .swWidget-dashboard-subTitle li {
            display: flex;

            span:last-child {
                margin-left: 4px;
            }
        }

        .widget-height-2 {
            .swWidget-frame {
                height: 670px !important;
            }
        }

        .widget-height-2 .swWidget-component {
            height: 570px !important;
        }

        .chartContainer image {
            display: none;
        }

        .swWidget-component {
            min-height: 200px;
            height: 230px !important; /* this solves the problem when last row cuts in half on certain tables */
            overflow: hidden;
        }

        .widget-size-2 .period-over-period-dashboard-subtitle .swWidget-dashboard-subTitle-country {
            display: block;
        }

        .swTable--simple .swReactTableCell {
            .value--leader {
                display: inline-table;

                div {
                    display: table-cell;
                }

                svg {
                    width: 14px;
                    height: 14px;
                }
            }
        }

        .keywords-table-overview-single {
            height: 70px !important;

            .single-search {
                height: 70px;
            }
        }

        .no-leader-icon-offset {
            margin-left: 12px;
        }

        .legend .legend-item {
            font-size: 14px;
            margin: 5px 5px 8px 13px;
        }
    }
`;

GridContainer.displayName = "GridContainer";

export const GridResizableHandle = styled.div`
    position: absolute;
    right: 10px;
    top: calc(50% - 32px / 2);
    z-index: 10;
    cursor: ew-resize;
`;
GridResizableHandle.displayName = "GridResizableHandle";

export const EmptyDashButtonsContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: -0.7rem;
    margin-right: -0.7rem;

    .inside-full {
        flex-basis: 100%;
        max-width: 100%;
    }
`;
EmptyDashButtonsContainer.displayName = "EmptyDashButtonsContainer";

export const DashboardWidgetHolder = styled.div<{ hideDraggable?: boolean }>`
    height: 100%;
`;
DashboardWidgetHolder.displayName = "DashboardWidgetHolder";
